export default __webpack_public_path__ + "static/media/cooking.135d250f.svg";